// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ITawO","list":"styles_list__2xKCe","disableSelection":"styles_disableSelection__1qSAa"};